<template>
  <div>
    <div
      v-for="(linkItem, index) in link"
      :key="index"
      :class="{
        'group whitespace-nowrap border-[0.1875rem] px-14px py-3 text-center text-13px font-bold leading-4 tracking-wider md:text-base md:leading-6 lg:text-lg lg:leading-6': true,
        'border-3px border-www-color-transparent bg-www-color-primary-lighter text-www-color-white hover:bg-www-color-primary focus:border-www-color-accent-blue-light focus:bg-www-color-primary active:bg-www-color-primary active:text-www-color-primary-lighter':
          color !== 'gray',
        'border-www-color-neutral-medium bg-www-color-neutral-medium text-www-color-white':
          color === 'gray',
        'flex items-center justify-center gap-14px capitalize': true,
      }"
    >
      <InternalLink
        v-if="linkItem._type == 'internalLink'"
        v-bind="linkItem"
        :class="{
          'flex items-center gap-2': true,
        }"
        ><template #default>
          <img
            alt=""
            :class="{
              'block md:hidden': true,
            }"
            :src="educationImageSrc"
            width="40"
          />
          {{ text }}
        </template></InternalLink
      >
      <ExternalLink
        v-if="linkItem._type == 'externalLink'"
        v-bind="linkItem"
        :class="{
          'flex items-center gap-2': true,
        }"
        ><img
          alt=""
          :class="{
            'block md:hidden': true,
          }"
          :src="educationImageSrc"
          width="40"
        />
        {{ text }}</ExternalLink
      >
    </div>
  </div>
</template>

<script setup lang="ts">
import ExternalLink from '~/components/Atmos/ExternalLink/ExternalLink.vue';
import InternalLink from '~/components/Atmos/InternalLink/InternalLink.vue';
import type { GeneralLink } from '~/sanity/types';

defineProps<GeneralLink & { color?: string }>();
const { $staticImages } = useNuxtApp();
const educationImageSrc = $staticImages['education'];
</script>

<style lang="scss" scoped></style>
